var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import styles from './MouseHoverPopoverModal.module.scss';
export function MouseHoverPopoverModal(_a) {
    var open = _a.open, anchorEl = _a.anchorEl, onClose = _a.onClose, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _b = _a.header, header = _b === void 0 ? 'Product Name' : _b, _c = _a.subTitle, subTitle = _c === void 0 ? 'Deviations' : _c, _d = _a.description, description = _d === void 0 ? 'None' : _d, _e = _a.buttonText, buttonText = _e === void 0 ? 'Open Quick View' : _e, _f = _a.showButton, showButton = _f === void 0 ? true : _f, onOpenPopover = _a.onOpenPopover;
    // Effect to handle scroll events when the popover is open
    useEffect(function () {
        var handleScroll = function () {
            if (open) {
                onClose();
            }
        };
        if (open) {
            window.addEventListener('scroll', handleScroll, true);
            return function () {
                window.removeEventListener('scroll', handleScroll, true);
            };
        }
        return undefined;
    }, [open, onClose]);
    return (_jsx(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, className: styles.popover, disableScrollLock: true, disableAutoFocus: true, disableEnforceFocus: true, disableRestoreFocus: true, PaperProps: {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            className: styles.popoverPaper,
        } }, { children: _jsxs(Box, { children: [_jsx(Typography, __assign({ className: styles.headerTitle }, { children: header })), _jsx(Box, { component: "hr", className: styles.headerDivider }), _jsx(Typography, __assign({ className: styles.subtitle }, { children: subTitle })), _jsx(Typography, __assign({ className: styles.description }, { children: description })), showButton && (_jsx(Button, __assign({ onClick: onOpenPopover, className: styles.actionButton }, { children: buttonText })))] }) })));
}
